package org.example.project.service

import kotlinx.browser.window
import kotlinx.coroutines.await
import org.example.project.manager.LumaticaApiManager
import org.w3c.fetch.RequestInit

object CompanionBridgeService {
    suspend fun disconnect() {
        val response = window.fetch("/node/companion/disconnect", RequestInit(method = "POST")).await()
        if (response.ok) {
            LoginService.clearLocalLogin()
            window.location.reload()
        }
    }
    suspend fun connect(): Boolean {
        val response = window.fetch(
            "/node/companion/connect",
            RequestInit(method = "POST", headers = LumaticaApiManager.auditHeaders())
        ).await()
        return response.ok
    }
}
